/** @param {Element[]} elementList */
export default function getHeightOfAllElements(
  elementList,
  { ignoreMargin = false } = {},
) {
  return elementList.reduce((totalHeight, el) => {
    // gets the rendered height, excluding margin
    const elementHeight = el.getBoundingClientRect().height;

    /**
     * calculate top/bottom margin as well
     * note that this does not account for collapsed margins between adjacent element siblings.
     * this is a rare case (most times, children will just be 1 element), so we won't account for it,
     * but it may calculate more height than is needed in some cases
     * */
    const elementStyle = window.getComputedStyle(el);
    let elementMargin = 0;
    if (!ignoreMargin) {
      const elementMarginTop = parseInt(
        elementStyle.getPropertyValue('margin-top'),
        10,
      );
      const elementMarginBottom = parseInt(
        elementStyle.getPropertyValue('margin-bottom'),
        10,
      );
      if (!Number.isNaN(elementMarginTop)) {
        elementMargin += elementMarginTop;
      }
      if (!Number.isNaN(elementMarginBottom)) {
        elementMargin += elementMarginBottom;
      }
    }

    return totalHeight + elementHeight + elementMargin;
  }, 0);
}
